import { FC } from "react";
export interface ICompanyIconProps {
  bgColor: string;
}
export const CompanyIcon: FC<ICompanyIconProps> = ({ bgColor }) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="48" height="48" rx="2" fill={bgColor} />
      <rect
        opacity="0.01"
        x="4.5"
        y="4.5"
        width="38.7706"
        height="38.7706"
        fill="black"
      />
      <path
        d="M35.717 20.065C35.664 20.2846 35.5352 20.6102 35.3535 21.0002H35.3573L35.3346 21.0381C34.2782 23.3022 31.5219 27.7396 31.5219 27.7396C31.5219 27.7396 31.5181 27.7282 31.5067 27.7131L30.7003 29.1178H34.5849L27.1715 38.9922L28.8564 32.2717H25.8009L26.8611 27.8267C26.0016 28.0349 24.9869 28.3189 23.7829 28.7051C23.7829 28.7051 22.1548 29.6592 19.0956 26.8688C19.0956 26.8688 17.0321 25.0476 18.2286 24.5933C18.7359 24.4002 20.6972 24.1541 22.2419 23.9458C24.3281 23.6619 25.6116 23.5142 25.6116 23.5142C25.6116 23.5142 19.1827 23.6089 17.6568 23.3703C16.131 23.1318 14.1963 20.5799 13.7836 18.3385C13.7836 18.3385 13.1475 17.108 15.1542 17.6911C17.1609 18.2741 25.4753 19.959 25.4753 19.959C25.4753 19.959 14.662 16.6385 13.9426 15.8283C13.2232 15.018 11.8261 11.406 12.0078 9.18727C12.0078 9.18727 12.0874 8.63449 12.6515 8.78215C12.6515 8.78215 20.6441 12.4396 26.1114 14.4425C31.5787 16.453 36.3303 17.4715 35.717 20.065Z"
        fill="white"
      />
    </svg>
  );
};
